<template>
  <Moveable
    class="moveable has-text-left"
    v-bind="moveable"
    :bounds="bounds"
    @drag="handleDrag"
    @dragEnd="handleDragEnd"
  >
    <span class="visual-signature">
      Remotely signed by: {{ name }} via eSig eID<br>
      Date: {{ date }} <br>
      Authentication before Signature via {{ authSource }} <!-- <br>
      Name: {{ name }} - Date {{ date }} -->
    </span>
  </Moveable>
</template>

<script>
import { mapGetters } from 'vuex'

import { tokenUtils } from '@/mixins/tokenUtils'

import Moveable from 'vue-moveable'

export default {
  name: 'SignatureMoveable',
  components: {
    Moveable
  },
  mixins: [tokenUtils],
  props: {
    bounds: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      date: '',
      name: '',
      authSource: '',
      moveable: {
        draggable: true,
        throttleDrag: 1,
        dragArea: true,
        resizable: false,
        keepRatio: false,
        scalable: false,
        rotatable: false,
        pinchable: false,
        snappable: true,
        origin: false
      }
    }
  },
  methods: {
    ...mapGetters([
      'getToken'
    ]),
    handleDrag ({ target, transform, clientX, clientY, dist, translate, left, top }) {
      target.style.transform = transform
      // console.log('X:', clientX)
      // console.log('Y:', clientY)
      // console.log('dist:', dist)
      // console.log('translate:', translate)
      // console.log('onDrag left, top', left, top)
    },
    handleDragEnd ({ target, clientX, clientY, isDrag, currentTarget }) {
      // console.log(target, isDrag)
      // console.log('X:', clientX)
      // console.log('Y:', clientY)

      localStorage.setItem('hasVisualSigPlacement', true)
      localStorage.setItem('xCoord', currentTarget.getRect().left)
      localStorage.setItem('yCoord', currentTarget.getRect().top)
    }
  },
  created () {
    this.date = new Date().toISOString()
    this.name = this.getLatinName(this.getToken())
    if (this.name === null || this.name === '' || this.name.length <= 0) {
      this.name = this.getGreekName(this.getToken())
    }
    this.authSource = this.getAuthSource(this.getToken())
  }
}
</script>

<style lang="scss">
.moveable {
  position: absolute;
  top: 0;
  right: 0;
}
.moveable-area {
  border:1px solid #29398A !important;
}
.visual-signature {
  font-size: 0.7rem;
  line-height: 0.1;
}
</style>
